$(document).ready(function() {
	$('.js-search-cg-gps').on('click', function(e) {
		e.preventDefault();
		navigator.geolocation.getCurrentPosition((position) => {
			$.getJSON('/wp-json/caregivers/fromPosition', {
				'latitude': position.coords.latitude,
				'longitude': position.coords.longitude
			}, function(result) {
				showCaregiverList(result)
			} )
		});
	});
	$('.js-search-caregivers').on('change', function(e) {
		e.preventDefault();
		var searchTerm = $(this).val();
		searchByTerm(searchTerm);
	});
	$('.js-search-cg-form').on('submit', function(e) {
		e.preventDefault();
		var searchTerm = $(this).find('.js-search-caregivers').val();
		searchByTerm(searchTerm);
	});
	function searchByTerm(searchTerm) {
		$.getJSON('/wp-json/caregivers/fromSearch', {
			's': searchTerm
		}, function(result) {
			showCaregiverList(result)
		});
	}
	function showCaregiverList(caregivers) {
		var $list = $('.js-list-caregivers');
		$list.html('');
		for(var i = 0; i < caregivers.length; i++) {
			var $cg = $(document.createElement('article')).addClass('pb-1 mb-1 border-b border-whisper');
			var $link = $(document.createElement('a')).attr('href', caregivers[i].link).html('<h1>' + caregivers[i].title + '</h1>');
			$cg.append($link);
			if(caregivers[i].distance) {
				$cg.append($(document.createElement('p')).text('Avstånd: ' + getDistanceText(caregivers[i].distance)))
			}
			$list.append($cg);
		}
	}
	var numFormat = new Intl.NumberFormat('sv-SE', { maximumSignificantDigits: 2 })
	function getDistanceText(distance) {
		if(distance < 1000) {
			return numFormat.format(distance) + 'm';
		} else {
			return numFormat.format(distance / 1000) + 'km';
		}
	}
});
